<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-progress-linear :indeterminate="true" class="ma-0" v-if="scanning"></v-progress-linear>

			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" mb-3>
				<div v-if="!scanning && !hasScanned">
					<div v-if="!scanning && !hasScanned" class="px-5">
						<img class="pt-2 pb-4 px-5" src="@/assets/images/e-finder-plugged.jpg" alt="Sluit je E-finder aan op het netstroom." width="100%">
					</div>

					<h3 class="mb-2">Voordat je begint:</h3>
					<ul>
						<li v-if="!bleEnabled">Schakel Bluetooth in op je telefoon</li>
						<li>Neem je WiFi Naam en Wachtwoord bij de hand</li>
						<li>Noteer de pincode die je zojuist per sms hebt ontvangen</li>
						<li>Sluit je E-finder aan op het netstroom</li>
					</ul>
				</div>

				<div v-if="scanning">
					<h3>Zoeken naar je E-finder</h3><br>
					<p>Een moment geduld aub...</p>
				</div>

				<div v-if="!scanning && hasScanned && !bleDevice">
					<div v-if="!message">
						<h3>Geen E-finder gevonden</h3><br>
						<ol>
							<li>Gebruik de meegeleverde kabel om je E-finder aan te sluiten aan het netstroom.</li>
							<li>Controleer of de code op je E-finder klopt: {{ device.eid.substr(-6) }}</li>
							<li>
								Zo wel:
								<ul>
									<li>Haal je E-finder even van het netstroom af en zet hem er dan weer aan.</li>
									<li>Klik hieronder op Opnieuw proberen.</li>
								</ul>
							</li>
							<li>Zo niet:
								<ul>
									<li>Klik onder aan de pagina op Code Wijzigen.</li>
								</ul>
							</li>
						</ol>
					</div>
					<div v-else>
						<h3 v-text="message"></h3><br>
						<ol>
							<li>Noteer de pincode die je zojuist per sms hebt ontvangen</li>
							<li>Controleer of de code op je E-finder klopt: {{ device.eid.substr(-6) }}</li>
							<li>
								Zo wel:
								<ul>
									<li>Haal je E-finder even van het netstroom af en zet hem er dan weer aan.</li>
									<li>Klik hieronder op Opnieuw proberen.</li>
								</ul>
							</li>
							<li>Zo niet:
								<ul>
									<li>Klik onder aan de pagina op Code Wijzigen.</li>
								</ul>
							</li>
						</ol>
					</div>
				</div>

				<div v-if="!scanning && bleDevice">
					<h3>E-finder verbonden</h3><br>

					<p>De volgende stap is het instellen van je WiFi. Als er nieuwe upgrades zijn voor de E-finder software wordt dit automatisch gedaan wanneer je je E-finder oplaadt.</p>

					<v-btn @click="complete()" block dark depressed large color="primary" class="mt-4">Verder</v-btn>
				</div>

				<v-btn v-else :loading="scanning || activating" @click="searchForDevice()" block dark depressed large
					   color="primary" class="mt-4">{{ !scanning && hasScanned && !bleDevice ? 'Opnieuw proberen' :
					'Verder'}}
				</v-btn>

			</v-container>

			<v-container v-if="!scanning && hasScanned && !bleDevice">
				<v-layout class="column align-center">
					<p>Is {{ device.id_for_humans }} de verkeerde code van je E-finder?</p>
					<v-btn depressed color="white" @click="gotoUpdateCode()">Code wijzigen</v-btn>
				</v-layout>
			</v-container>

		</v-content>
	</div>
</template>

<script>
  import moment from 'moment';
  import DeviceService from '../../../services/DeviceService';

  import badgePlayStore from '../../../assets/images/badge-nl-google-play.png';
  import badgeAppStore from '../../../assets/images/badge-nl-app-store.svg';

  let checkForBleServiceInterval;

  const characteristics = {
    activation: {
      uuid: '1fb91a52-0000-49da-a31a-0401cc94acc4'
    },
    activationSuccess: {
      uuid: 'eac0d61a-0002-e3f3-baeb-38ddd4847eb'
    },
    ssid: {
      uuid: 'eac0d61a-0000-e3f3-baeb-38ddd48474eb'
    },
    password: {
      uuid: 'eac0d61a-0001-e3f3-baeb-38ddd48474eb'
    },
    isFound: {
      uuid: 'c01ff0ad-0000-43b9-a6ef-cf71ba1eb665'
    },
  };

  function stringToBytes(_str) {
    let str = _str + '';
    let a = new Uint8Array(str.length);
    for (let i = 0, l = str.length; i < l; i++) {
      a[i] = str.charCodeAt(i);
    }
    return a.buffer;
  }

  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
      disabled() {
        return this.wifiName === '' || this.wifiKey === '';
      },
      userLocation() {
        return this.$store.state.location.coordinates;
      },
      isRunningInBrowser() {
        return process.env.CORDOVA_PLATFORM === 'browser';
      }
    },
    data() {
      return {
        message: null,
        images: {
          badgeAppStore: badgeAppStore,
          badgePlayStore: badgePlayStore
        },
        bleEnabled: false,
        bleDevice: null,
        scanning: false,
        activating: false,
        hasScanned: false,
        inputRules: [v => !!v || 'Vereist veld'],
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      goBack() {
        if (this.hasScanned) {
          this.bleDevice = null;
          return this.hasScanned = false;
        }

        this.$router.push({ name: 'devices.activate', params: { id: this.$route.params.id } });
      },
      gotoUpdateCode() {
        this.$router.push({ name: 'devices.activate.code', params: { id: this.device.id } });
      },

      checkForBleService() {
        if (typeof ble === 'undefined') return false;
        ble.isEnabled(() => this.enableBle(), () => this.disableBle());
      },

      enableBle() {
        if (this.bleEnabled) return;
        this.bleEnabled = true;
      },

      disableBle() {
        if (!this.bleEnabled) return;
        this.bleEnabled = false;
      },

      searchForDevice() {
        if (typeof ble === 'undefined') return false;

        this.message = null;
        this.scanning = true;
        this.hasScanned = true;

        ble.startScan([], (device) => {
          if (!device.name || !device.id) return;

          console.log('SCAN:' + device.name);

          if (device.advertising && device.advertising.kCBAdvDataLocalName)
            device.name = device.advertising.kCBAdvDataLocalName;

          if (device.name.substr(-6) == this.device.eid.substr(-6)) {
            ble.stopScan();
            this.connectDevice(device.id);
          }
        });

        setTimeout(ble.stopScan, 10000,
          () => this.scanning = false,
          () => this.scanning = false
        );
      },

      connectDevice(deviceId) {
        if (typeof ble === 'undefined') return false;

        ble.connect(deviceId,
          (device) => {
            // if (!this.validateDevice(device)) return;
            this.bleDevice = device;
          },
          () => {
            this.message = 'Verbinden mislukt';
            this.scanning = false;
            this.activating = false;
            this.bleDevice = null;
          });
      },

      getCharacteristic(uuid, device = null) {
        device = device === null ? this.bleDevice : device;

        if (!device && !device.characteristics) return undefined;

        return device.characteristics.find(deviceCharacteristic => {
          return deviceCharacteristic.characteristic.toUpperCase() === uuid.toUpperCase();
        });
      },

      getCharacteristicOnService(service, characteristic, device = null) {
        device = device === null ? this.bleDevice : device;

        if (!device && !device.characteristics) return undefined;

        return device.characteristics.find(deviceCharacteristic => {
          return deviceCharacteristic.characteristic.toUpperCase() === characteristic.toUpperCase()
			&& deviceCharacteristic.service.toUpperCase() === service.toUpperCase();
        });
      },

      validateDevice() {
        let requiredCharacteristics = Object.keys(characteristics)
          .reduce((arr, key) => [...arr, characteristics[key]], [])
          .filter(characteristic => {
            return this.getCharacteristic(characteristic.uuid) === undefined;
          });

        return (requiredCharacteristics.length <= 1);
      },

      complete() {
        this.$router.replace({ name: 'devices.activate.wifi', params: { id: this.$route.params.id } });

        // this.$router.replace({ name: 'devices.activate.wifi', params: { id: this.$route.params.id } });

        // try {
        //   await this.activateDevice();
        // } catch (e) {
        //   this.message = 'Verbinden mislukt';
        //   this.scanning = false;
        //   this.activating = false;
        //   this.bleDevice = null;
        //   return;
        // }

        // const data = { activated_at: true };
		//
        // if (!this.device.latest_state && this.userLocation && this.userLocation.lat != 0 && this.userLocation.lng != 0) {
		//
        //   const state = {
        //     accuracy: '10',
        //     battery_percentage: '-',
        //     battery_status: '-',
        //     battery_voltage: '5',
        //     btle_address: '',
        //     deadtime_delay: '5',
        //     firmware: '-',
        //     gateway_location: this.userLocation,
        //     is_moving: false,
        //     location: this.userLocation,
        //     measure_interval: '5',
        //     message_interval: '1440',
        //     processed_at: moment(),
        //     received_at: moment(),
        //     send_at: moment(),
        //     state: 'Standard',
        //     state_id: null,
        //     type: 'gps',
        //     updated_at: moment(),
        //     wifi_result: ''
        //   };
		//
        //   data.latest_state = state;
		//
        //   let handled = false;
		//
        //   await DeviceService.createDeviceState(this.device.id, this.userLocation)
        //     .catch(e => {
        //       if (e.status === 422) handled = true;
        //     });
		//
        //   if (!handled) return;
        // }
		//
        // this.$store.dispatch('updateDevice', {
        //   id: this.device.id,
        //   data: data
        // })
        //   .then(() => {
        //     this.$router.replace({ name: 'devices.activate.link-success', params: { id: this.$route.params.id } });
        //   });
      },

      // activateDevice() {
      //   return new Promise((resolve, reject) => {
      //     if (!this.bleDevice) return reject();
	  //
      //     const characteristic = this.getCharacteristic(characteristics.activation.uuid);
      //     const characteristicSuccess = {
      //       service: '1fb91a52-a1db-49da-a31a-0401cc94acc4',
		// 	characteristic: 'eac0d61a-0002-e3f3-baeb-38ddd4847eb'
		//   };
	  //
      //     let data = new Uint8Array(1);
      //     data[0] = 1;
	  //
      //     if(this.hasCharacteristicAndService(characteristicSuccess.characteristic, characteristicSuccess.service)) {
      //       const timeout = setTimeout(() => {
      //         ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
      //         reject();
      //       }, 10000);
	  //
      //       ble.startNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic, (data) => {
      //         ble.stopNotification(this.bleDevice.id, characteristicSuccess.service, characteristicSuccess.characteristic);
      //         clearTimeout(timeout);
      //         resolve();
      //       });
	  //
      //       ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer, () => null, () => reject());
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 1000);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 2000);
      //     } else {
      //       ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 1000);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 2500);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 5000);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer), 7500);
      //       setTimeout(() => ble.write(this.bleDevice.id, characteristic.service, characteristic.characteristic, data.buffer, () => resolve(), () => reject()), 10000);
		//   }
      //   });
      // },
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id);
      this.checkForBleService();
      checkForBleServiceInterval = setInterval(this.checkForBleService, 3000);
    },
    beforeDestroy() {
      if (typeof ble === 'undefined') return;
      ble.stopScan();
      clearInterval(checkForBleServiceInterval);
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
